export default __webpack_public_path__ + "static/media/PhantomSans0.8-Regular.5d2bff37.woff";